<template>
    <div>


        <v-container fluid class="grey lighten-4" style="min-height: 100vh;">
            <v-row justify="center">
                <v-col cols="12" xl="12">
                    <v-card class="mb-6" elevation="3">
                        <v-card-title class="justify-center">
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <h1 class="text-center primary--text">
                                        Gestor de Certificaciones Universitaria
                                    </h1>
                                </v-col>
                                <v-col>
                                    <h4>{{ program.nombre_compuesto }}</h4>
                                    <h5>{{ program.sede.nombre }}</h5>
                                    <!--<h5>{{ program.codigo }}</h5>-->
                                </v-col>
                            </v-row>
                        </v-card-title>
                    </v-card>

                    <v-card elevation="3" class="mb-6">
                        <v-card-title>
                            <v-icon left>mdi-school</v-icon>
                            Configuración del Programa
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-model="nombreProgramaUniversidad" label="Nombre del Programa *"
                                placeholder="Ej: Diplomado en Marketing Digital" outlined dense
                                prepend-icon="mdi-book-open-variant" class="mb-4"></v-text-field>

                            <v-card outlined class="pa-4 grey lighten-5">
                                <v-card-subtitle class="pa-0 mb-3">
                                    <v-icon small left>mdi-certificate</v-icon>
                                    {{ editingIndex >= 0 ? 'Editar' : 'Nueva' }} Certificación
                                </v-card-subtitle>

                                <v-row>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-select v-model="currentCertification.university" :items="universities"
                                            item-text="nombre" item-value="id" label="Universidad *" outlined dense
                                            prepend-icon="mdi-account-school"
                                            :rules="[v => !!v || 'La universidad es requerida']"></v-select>
                                    </v-col>

                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field v-model="currentCertification.amount" label="Monto Total (Bs.) *"
                                            type="number" outlined prepend-icon="mdi-currency-usd"
                                            :rules="[v => !!v || 'El monto es requerido']" dense step="0.01"
                                            min="0"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="4">
                                        <v-combobox v-model="seleccionado" :items="conceptos" label="* Concepto de pago"
                                            :loading="loadingconceptos" :disabled="loadingconceptos" loader-height="4"
                                            placeholder="tecla enter para buscar..." prepend-inner-icon="mdi-cart"
                                            return-object hide-details outlined dense></v-combobox>
                                    </v-col>

                                    <v-col cols="12" md="6" lg="4">
                                        <v-text-field v-model="currentCertification.concept" label="Concepto *" outlined
                                            prepend-icon="mdi-text" placeholder="Ej: Certificación del programa"
                                            :rules="[v => !!v || 'El concepto es requerido']"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" md="6" lg="4">
                                        <v-select v-model="currentCertification.paymentType" :items="paymentTypes"
                                            item-text="text" item-value="value" label="Tipo de Pago" outlined
                                            prepend-icon="mdi-credit-card" @change="onPaymentTypeChange"></v-select>
                                    </v-col>

                                    <v-col cols="12" md="6" lg="4" v-if="currentCertification.paymentType === 'cuotas'">
                                        <v-text-field v-model="currentCertification.installments"
                                            label="Número de Cuotas" type="number" outlined
                                            prepend-icon="mdi-calendar-multiple" min="2" max="12"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" md="6" lg="4"
                                        v-if="currentCertification.paymentType === 'cuotas' && currentCertification.amount">
                                        <v-text-field :value="calculateInstallmentAmount()"
                                            label="Monto por Cuota (Bs.)" outlined prepend-icon="mdi-calculator"
                                            readonly disabled></v-text-field>
                                    </v-col>

                                    <!-- <v-col cols="12">
                                  <v-divider class="mb-4"></v-divider>
                                  <h3 class="mb-3">
                                      <v-icon left>mdi-file-image</v-icon>
                                      Formato del Certificado (Opcional)
                                  </h3>
                                  
                                  <v-file-input
                                      v-model="currentCertification.certificateImage"
                                      label="Subir imagen del certificado"
                                      accept="image/*"
                                      outlined
                                      prepend-icon="mdi-camera"
                                      show-size
                                      @change="onImageChange"
                                  ></v-file-input>

                                  <v-card v-if="currentCertification.imagePreview" outlined class="mt-3">
                                      <v-img
                                          :src="currentCertification.imagePreview"
                                          max-height="300"
                                          contain
                                      ></v-img>
                                  </v-card>
                              </v-col> -->

                                    <!-- <v-col cols="12" >
                                  <v-divider class="mb-4"></v-divider>
                                  <h3 class="mb-3">
                                      <v-icon left>mdi-cog</v-icon>
                                      Configuración de Campos del Certificado
                                  </h3> -->

                                    <!-- <v-expansion-panels accordion>
                                      <v-expansion-panel
                                          v-for="(field, fieldKey) in currentCertification.certificateFields"
                                          :key="fieldKey"
                                          
                                      >
                                      
                                          <v-expansion-panel-header>
                                              <v-icon left>{{ getFieldIcon(fieldKey) }}</v-icon>
                                              {{ getFieldLabel(fieldKey) }}
                                              <v-spacer></v-spacer>
                                              <v-chip small color="primary" outlined>
                                                  X: {{ field.posicion ? field.posicion.x : 'N/A' }}, Y: {{ field.posicion ? field.posicion.y : 'N/A' }}
                                              </v-chip>
                                          </v-expansion-panel-header>
                                          <v-expansion-panel-content>
                                              <v-row>
                                                  <v-col cols="12" md="3">
                                                      <v-text-field
                                                          v-model="field.posicion.x"
                                                          label="Posición X"
                                                          type="number"
                                                          outlined
                                                          dense
                                                      ></v-text-field>
                                                  </v-col>
                                                  <v-col cols="12" md="3">
                                                      <v-text-field
                                                          v-model="field.posicion.y"
                                                          label="Posición Y"
                                                          type="number"
                                                          outlined
                                                          dense
                                                      ></v-text-field>
                                                  </v-col>
                                                  
                                                  <v-col cols="12" md="3" v-if="field.tamano !== undefined">
                                                      <v-text-field
                                                          v-model="field.tamano"
                                                          label="Tamaño Fuente"
                                                          type="number"
                                                          outlined
                                                          dense
                                                      ></v-text-field>
                                                  </v-col>

                                                  <v-col cols="12" md="3">
                                                      <v-text-field
                                                          v-model="field.ancho"
                                                          label="Ancho"
                                                          type="number"
                                                          outlined
                                                          dense
                                                      ></v-text-field>
                                                  </v-col>

                                                  <v-col cols="12" md="3" v-if="field.alto !== undefined">
                                                      <v-text-field
                                                          v-model="field.alto"
                                                          label="Alto"
                                                          type="number"
                                                          outlined
                                                          dense
                                                      ></v-text-field>
                                                  </v-col>

                                                  <v-col cols="12" md="3" v-if="field.centrado !== undefined">
                                                      <v-switch
                                                          v-model="field.centrado"
                                                          label="Centrado"
                                                          inset
                                                      ></v-switch>
                                                  </v-col>

                                                  <v-col cols="12" v-if="field.valor !== undefined && !['foto', 'qr'].includes(fieldKey)">
                                                      <v-text-field
                                                          v-model="field.valor"
                                                          :label="`Valor por defecto - ${getFieldLabel(fieldKey)}`"
                                                          outlined
                                                          dense
                                                      ></v-text-field>
                                                  </v-col>

                                                  <v-col cols="12" v-if="fieldKey === 'qr'">
                                                      <v-text-field
                                                          v-model="field.url"
                                                          label="URL del QR"
                                                          outlined
                                                          dense
                                                      ></v-text-field>
                                                  </v-col>
                                              </v-row>
                                          </v-expansion-panel-content>
                                      </v-expansion-panel>
                                  </v-expansion-panels> -->

                                    <!-- <v-card outlined class="mt-4 pa-3">
                                      <v-card-subtitle class="pa-0">
                                          <v-icon small left>mdi-tune</v-icon>
                                          Configuraciones Adicionales
                                      </v-card-subtitle>
                                      <v-row>
                                          <v-col cols="12" md="4">
                                              <v-text-field
                                                  v-model="currentCertification.certificateFields.verificacion_url"
                                                  label="URL de Verificación"
                                                  outlined
                                                  dense
                                              ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" md="4">
                                              <v-text-field
                                                  v-model="currentCertification.certificateFields.ajuste"
                                                  label="Ajuste"
                                                  type="number"
                                                  outlined
                                                  dense
                                              ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" md="4">
                                              <v-switch
                                                  v-model="currentCertification.certificateFields.is_fondo"
                                                  label="Es Fondo"
                                                  inset
                                              ></v-switch>
                                          </v-col>
                                      </v-row>
                                  </v-card> -->
                                    <!-- </v-col> -->

                                </v-row>

                                <v-row class="mt-3">
                                    <v-col cols="12">
                                        <v-btn @click="addCertification" color="primary" :disabled="!isFormValid"
                                            class="mr-3">
                                            <v-icon left>{{ editingIndex >= 0 ? 'mdi-content-save' : 'mdi-plus'
                                            }}</v-icon>
                                            {{ editingIndex >= 0 ? 'Actualizar' : 'Agregar' }} Certificación
                                        </v-btn>

                                        <v-btn v-if="editingIndex >= 0" @click="cancelEdit" color="grey" outlined>
                                            <v-icon left>mdi-cancel</v-icon>
                                            Cancelar
                                        </v-btn>

                                        <v-btn v-if="currentCertification.certificateImage"
                                            @click="generateCertificateJSON" color="success" outlined class="ml-3">
                                            <v-icon left>mdi-code-json</v-icon>
                                            Ver JSON
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-card-text>
                    </v-card>

                    <v-card v-if="program && certifications.length > 0" elevation="3">
                        <v-card-title>
                            <v-icon left>mdi-format-list-bulleted</v-icon>
                            Certificaciones para:
                            <span class="primary--text ml-2">{{ program.nombre_compuesto }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-data-table :headers="headers" :items="certificationsWithIndexedItems"
                                :items-per-page="10" class="elevation-1">
                                <template v-slot:item.precio="{ item }">
                                    {{ item.moneda }}. {{ parseFloat(item.precio).toFixed(2) }}
                                </template>

                                <!-- <template v-slot:item.paymentInfo="{ item }">
                              <v-chip
                                  :color="item.paymentType === 'unico' ? 'success' : 'info'"
                                  small
                                  text-color="white"
                              >
                                  <v-icon left small>
                                      {{ item.paymentType === 'unico' ? 'mdi-check-circle' : 'mdi-calendar-multiple' }}
                                  </v-icon>
                                  {{ item.paymentType === 'unico' 
                                      ? 'Pago Único' 
                                      : `${item.installments} cuotas de Bs. ${(parseFloat(item.amount) / item.installments).toFixed(2)}` 
                                  }}
                              </v-chip>
                          </template> -->

                                <template v-slot:item.hasCertificate="{ item }">
                                    <v-chip :color="item.certificateImage ? 'success' : 'grey'" small
                                        text-color="white">
                                        <v-icon left small>
                                            {{ item.certificateImage ? 'mdi-check' : 'mdi-close' }}
                                        </v-icon>
                                        {{ item.certificateImage ? 'Sí' : 'No' }}
                                    </v-chip>
                                </template>

                                <template v-slot:item.actions="{ item, index }">
                                    <v-btn @click="editCertification(item.index)" color="primary" icon small
                                        class="mr-2">
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn v-if="item.certificateImage" @click="viewCertificateJSON(item.index)"
                                        color="success" icon small class="mr-2">
                                        <v-icon small>mdi-code-json</v-icon>
                                    </v-btn>
                                    <v-btn @click="deleteCertification(item.index)" color="error" icon small>
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>

                            <v-card outlined class="mt-4 grey lighten-5">
                                <v-card-title class="subtitle-1">
                                    <v-icon left>mdi-chart-box</v-icon>
                                    Resumen
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <div class="text-body-2">
                                                <strong>Total de universidades:</strong>
                                                <span class="primary--text">{{ certifications.length }}</span>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="text-body-2">
                                                <strong>Con formato:</strong>
                                                <span class="success--text">{{ certificationsWithImage }}</span>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="text-body-2">
                                                <strong>Rango de precios:</strong>
                                                <span class="primary--text">
                                                    Bs. {{ getMinPrice() }} - Bs. {{ getMaxPrice() }}
                                                </span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>

                    <v-card v-if="program && certifications.length === 0" elevation="3" class="text-center">
                        <v-card-text class="py-8">
                            <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-certificate-outline</v-icon>
                            <div class="text-h6 grey--text">No hay certificaciones agregadas para este programa</div>
                            <div class="text-body-2 grey--text mt-2">Completa el formulario arriba para agregar la
                                primera certificación
                            </div>
                        </v-card-text>
                    </v-card>

                    <v-dialog v-model="jsonDialog" max-width="800px">
                        <v-card>
                            <v-card-title>
                                <v-icon left>mdi-code-json</v-icon>
                                Configuración JSON del Certificado
                            </v-card-title>
                            <v-card-text>
                                <pre class="grey lighten-4 pa-3"
                                    style="overflow-x: auto; font-size: 12px;">{{ formattedJSON }}</pre>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="copyJSON" color="primary" outlined>
                                    <v-icon left>mdi-content-copy</v-icon>
                                    Copiar
                                </v-btn>
                                <v-btn @click="jsonDialog = false" color="grey" text>
                                    Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" top>
                        {{ snackbar.message }}
                        <template v-slot:action="{ attrs }">
                            <v-btn text v-bind="attrs" @click="snackbar.show = false">
                                Cerrar
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-col>
            </v-row>
        </v-container>
       
            <CertificateConfigurator />
       
    </div>

</template>

<script>
import CertificateConfigurator from './CertificateConfigurator.vue'
import axios from 'axios';
import gql from 'graphql-tag';
import xaxios from '@/xaxios';



const API_URL = `${process.env.VUE_APP_API_CERTIFICACIONES}/api/v1`;

export default {
    data() {
        return {
            programaId: null,
            nombreProgramaUniversidad: '',
            elements: [],
            selectedElement: null,
            backgroundImage: null,
            paperSize: 'A4-landscape',
            dragOffset: { x: 0, y: 0 },
            isDragging: false,
            paperSizes: {
                'A4-landscape': { width: 1123, height: 794, label: 'A4 Horizontal (29.7x21 cm)' },
                'A4-portrait': { width: 794, height: 1123, label: 'A4 Vertical (21x29.7 cm)' },
                'letter-landscape': { width: 1056, height: 816, label: 'Carta Horizontal (27.9x21.6 cm)' },
                'letter-portrait': { width: 816, height: 1056, label: 'Carta Vertical (21.6x27.9 cm)' }
            },
            program: '',
            certifications: [],
            editingIndex: -1,
            jsonDialog: false,
            formattedJSON: '',
            snackbar: {
                show: false,
                message: '',
                color: 'success'
            },
            universities: [
                'Universidad Nacional de La Paz',
                'Universidad Mayor de San Andrés',
                'Universidad Católica Boliviana',
                'Universidad Privada de Bolivia',
                'Universidad Franz Tamayo',
                'Universidad del Valle',
                'Universidad NUR',
                'Universidad de Aquino Bolivia'
            ],
            paymentTypes: [
                { text: 'Pago Único', value: 'unico' },
                { text: 'Pago en Cuotas', value: 'cuotas' }
            ],
            conceptos: [],

            currentCertification: {
                university: '',
                amount: '',
                concept: '',
                installments: 1,
                paymentType: 'unico',
                certificateImage: null,
                imagePreview: null,
                certificateFields: this.getDefaultCertificateFields()
            },
            headers: [
                { text: '#', value: 'index', sortable: false, width: '60px' },
                { text: 'Universidad', value: 'Universidad.Nombre', sortable: true },
                { text: 'Universidad', value: 'nombre_programa', sortable: true },
                { text: 'Concepto', value: 'Concepto.nombre', sortable: true },
                { text: 'Monto Total', value: 'precio', sortable: true },
                //   { text: 'Modalidad de Pago', value: 'paymentInfo', sortable: false },
                { text: 'Tiene Formato', value: 'hasCertificate', sortable: false },
                { text: 'Acciones', value: 'actions', sortable: false, width: '150px' }
            ]
        }
    },
    computed: {
        currentPaperSize() {
            return this.paperSizes[this.paperSize]
        },
        selectedEl() {
            return this.elements.find(el => el.id === this.selectedElement)
        },

        isFormValid() {
            // Asegúrate de que los campos obligatorios estén llenos
            let isValid = this.currentCertification.university &&
                this.currentCertification.amount &&
                this.currentCertification.concept;

            // Si es pago en cuotas, verifica que el número de cuotas sea válido
            if (this.currentCertification.paymentType === 'cuotas') {
                isValid = isValid && this.currentCertification.installments >= 2;
            }
            return isValid;
        },
        certificationsWithImage() {
            return this.certifications.filter(cert => cert.certificateImage).length;
        },
        // Añadimos esta computed property para la tabla, para incluir el índice
        certificationsWithIndexedItems() {
            return this.certifications.map((item, index) => ({ ...item, index }));
        }
    },
    async created() {
        this.programaId = this.$route.params.programaId
        await this.fetchPrograma()
        await this.getProgramasUniversidadCertificados()
        await this.getConveniosUniversidades()
        await this.getconceptos()
    },
    watch: {
        '$route.params.programaId'(newId, oldId) {
            if (newId !== oldId) {
                this.programaId = newId
                this.fetchPrograma()
                this.getProgramasUniversidadCertificados()
                this.getConveniosUniversidades()
            }
        },

        selectedEl(newVal) {
            if (newVal) {
                // Add cm properties for easier editing
                newVal.xCm = this.pxToCm(newVal.x)
                newVal.yCm = this.pxToCm(newVal.y)
                newVal.widthCm = this.pxToCm(newVal.width)
                newVal.heightCm = this.pxToCm(newVal.height)
            }
        }
    },
    components: { CertificateConfigurator },

    methods: {
        getconceptos() {
        let vue = this;
        vue.loadingconceptos = true;
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        // let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos`;
        // let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/{CONCEPTOID:[1-9][0-9]{0,8}}/unidadnegocio/{UNIDADNEGOCIOID:[1-9][0-9]{0,8}}/nit/{NITID:[1-9][0-9]{0,8}}`;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/unidadnegocio/${unidad}/nit/2`;

        xaxios
          .get(url)
          .then(function(response) {
            let data = response.data.data; 
            data.map((c) => {
              if(c){
                c.text = `[${c.concepto_pago.monto}bs] ${c.concepto_pago.nombre} (${c.concepto_pago.descripcion})`;
              }
            });
            vue.conceptos = data;
            vue.loadingconceptos = false; 
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingconceptos = false;
          });
      },
        async getConveniosUniversidades() {
            // let vue = this;
            this.loading = true;
            const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
            this.$apollo.query({ query: sql }).then(({ data }) => {
                let conves = data.getInstituciones;
                conves = conves.filter(x => { return x.convenio });
                this.universities = conves;
                this.loading = false;
            });
        },
        async fetchPrograma() {
            var sql = gql`query{ getPrograma(id:${this.programaId}){id,version,nombre_compuesto,grupo,fecha_inicio,fecha_fin,gestion,postgrado{ objetivo,dirigido,duracion,unidad_duracion,creditaje,carga_horaria,programas{id},categoria{nombre},area{nombre} },sede{nombre},fase,mod_finalizado,universidad{nombre},programa_modulos{id,course_id,modulo{	id,nombre},docente{nombres,pri_apellido,seg_apellido},numero,inicio,fin,puntuacion,estado}} }`;
            //var sql = gql`query{ getPrograma(id:${this.programa.id}){id,version,grupo,fecha_inicio,fecha_fin,gestion,postgrado{nombre,categoria{nombre}},sede{nombre},monto_matricula,monto_colegiatura,monto_certificacion,fase,cuotas,mod_finalizado,universidad{nombre},programa_modulos{modulo{	id,nombre},numero,inicio,fin,puntuacion,concluido}} }`;
            // window.console.log( sql )
            await this.$apollo
                .query({
                    query: sql,
                })
                .then((data) => {
                    this.program = data.data.getPrograma;
                    //window.console.log( "GET PROGRMA::: ",JSON.stringify(vue.programa,null,4) )
                    if (this.program == null) {
                        //this.$notify(error('ERROR', 'getPrograma'));
                        return;
                    }

                    this.program.programa_modulos.sort(function (a, b) {
                        return a.numero - b.numero;
                    });
                    this.cargado = true;
                    this.courseid = this.program.programa_modulos;
                })
                .catch((error) => {
                    window.console.log(error)
                    this.cargado = true;
                    // this.$notify(parseJsonError(error, 'getPrograma'));
                });

            let url = `${this.api_rest}/esam/programa/id/${this.programaId}`;
            // var myHeaders = new Headers();
            // myHeaders.append("Content-Type", "application/json");
            // myHeaders.append("Authorization", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImNhcmdvcyI6WyIxIiwiMSIsIjEiLCIxIiwiMSIsIjEiLCIxIiwiMSIsIjEiLCIxIiwiMSIsIjEiLCIxIl0sImlhdCI6MTYxODIzNTY1NCwiZXhwIjoxNjE4MjM2NTU0fQ.xPKZ8FCfimRxA0XcvHjcmaNmUOrhuL7hCNRIuj2o-UY");

            // var requestOptions = { method: 'GET', headers: myHeaders,};
            // fetch(url, requestOptions)
            //   .then(response => response.json())
            //   .then(result => {
            //     window.console.log(result)
            //   })
            //   .catch(error => {window.console.log('error', error)});

            //window.console.log(url);
            await xaxios.get(url).then(({ data: { datos_coordinador, datos_responsable } }) => {
                //window.console.log(datos_coordinador, datos_responsable);
                if (datos_coordinador) {
                    let { coordinador } = datos_coordinador;
                    this.coordinador =
                        datos_coordinador && coordinador
                            ? `${coordinador.nombres} ${coordinador.primer_apellido} ${coordinador.segundo_apellido}`
                            : null;
                }
                if (datos_responsable) {
                    let { responsable } = datos_responsable;
                    this.responsable =
                        datos_responsable && responsable
                            ? `${responsable.nombres} ${responsable.primer_apellido} ${responsable.segundo_apellido}`
                            : null;
                }
            });
        },

        async getProgramasUniversidadCertificados() {
            try {

                //        const response = await axios.get(`${API_URL}/programas/universidad/certificado`);
                const response = await axios.get(`${API_URL}/programas/${this.programaId}/universidad/certificado`);

                this.certifications = response.data || [];
            } catch (error) {
                window.console.error("Error al obtener los programas:", error);
                alert("No se pudieron cargar los datos.");
            }
        },
        pxToCm(px) {
            return (px / 37.795).toFixed(1)
        },
        cmToPx(cm) {
            return cm * 37.795
        },
        addElement(type) {
            const newElement = {
                id: Date.now(),
                type,
                x: 100,
                y: 100,
                width: type === 'qr' ? 100 : 200,
                height: type === 'qr' ? 100 : type === 'image' ? 150 : 50,
                content: type === 'text' ? 'Nuevo texto' : type === 'qr' ? 'https://ejemplo.com' : '',
                fontSize: 16,
                fontFamily: 'Arial',
                color: '#000000',
                backgroundColor: 'transparent',
                rotation: 0,
                imageUrl: null,
                textAlign: 'center',
                name: `${type === 'text' ? 'Texto' : type === 'image' ? 'Imagen' : 'QR'} ${this.elements.length + 1}`,
                visible: true,
                xCm: this.pxToCm(100),
                yCm: this.pxToCm(100),
                widthCm: type === 'qr' ? this.pxToCm(100) : this.pxToCm(200),
                heightCm: type === 'qr' ? this.pxToCm(100) : type === 'image' ? this.pxToCm(150) : this.pxToCm(50)
            }

            this.elements.push(newElement)
            this.selectedElement = newElement.id
        },
        updateElement(id, updates) {
            this.elements = this.elements.map(el =>
                el.id === id ? { ...el, ...updates } : el
            )
        },
        deleteElement(id) {
            this.elements = this.elements.filter(el => el.id !== id)
            if (this.selectedElement === id) {
                this.selectedElement = null
            }
        },
        handleMouseDown(e, elementId) {
            e.preventDefault()
            this.selectedElement = elementId
            this.isDragging = true

            const rect = e.currentTarget.getBoundingClientRect()
            const containerRect = e.currentTarget.parentElement.getBoundingClientRect()
            window.console.log(containerRect)

            this.dragOffset = {
                x: e.clientX - rect.left,
                y: e.clientY - rect.top
            }
        },
        handleMouseMove(e) {
            if (!this.isDragging || !this.selectedElement) return

            const container = document.getElementById('certificate-canvas')
            const containerRect = container.getBoundingClientRect()

            const newX = e.clientX - containerRect.left - this.dragOffset.x
            const newY = e.clientY - containerRect.top - this.dragOffset.y

            this.updateElement(this.selectedElement, {
                x: Math.max(0, Math.min(newX, this.currentPaperSize.width - 100)),
                y: Math.max(0, Math.min(newY, this.currentPaperSize.height - 50)),
                xCm: this.pxToCm(Math.max(0, Math.min(newX, this.currentPaperSize.width - 100))),
                yCm: this.pxToCm(Math.max(0, Math.min(newY, this.currentPaperSize.height - 50)))
            })
        },
        handleMouseUp() {
            this.isDragging = false
        },
        handleFileUpload(e, elementId = null) {
            const file = e.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (event) => {
                    if (elementId) {
                        this.updateElement(elementId, { imageUrl: event.target.result })
                    } else {
                        this.backgroundImage = event.target.result
                    }
                }
                reader.readAsDataURL(file)
            }
            e.target.value = null // Reset input to allow selecting same file again
        },
        // Método para obtener la estructura inicial de los campos del certificado
        getDefaultCertificateFields() {
            return {
                nombre_estudiante: {
                    valor: "",
                    posicion: { x: 0, y: -33 },
                    tamano: 28,
                    ancho: 150,
                    alto: 15,
                    centrado: true
                },
                nombre_curso: {
                    valor: "",
                    posicion: { x: 0, y: 20 },
                    tamano: 15,
                    ancho: 180,
                    alto: 10,
                    centrado: true
                },
                ci: {
                    valor: "",
                    posicion: { x: 175, y: 95.5 },
                    tamano: 16,
                    ancho: 0,
                    centrado: false
                },
                creditos: {
                    valor: "20",
                    posicion: { x: 146.5, y: 150.8 },
                    tamano: 14,
                    ancho: 0,
                    centrado: false
                },
                dia: {
                    valor: "",
                    posicion: { x: 105.8, y: 161.70 },
                    tamano: 14,
                    ancho: 0,
                    centrado: false
                },
                mes: {
                    valor: "",
                    posicion: { x: 153, y: 161.70 },
                    tamano: 14,
                    ancho: 0,
                    centrado: false
                },
                anio: {
                    valor: "",
                    posicion: { x: 172, y: 161.70 },
                    tamano: 12,
                    ancho: 0,
                    centrado: false
                },
                codigo: {
                    valor: "",
                    posicion: { x: 215, y: 205 },
                    tamano: 14,
                    ancho: 0,
                    centrado: false
                },
                foto: {
                    valor: "", // Este valor generalmente no se usa para la foto, pero se mantiene la estructura
                    posicion: { x: 218, y: 52 },
                    ancho: 30,
                    alto: 30
                },
                qr: {
                    url: "",
                    posicion: { x: 240, y: 160 },
                    ancho: 25
                },
                verificacion_url: "https://certificados.upi.bo/verificar/",
                is_fondo: true,
                ajuste: 0
            };
        },

        getFieldLabel(fieldKey) {
            const labels = {
                nombre_estudiante: 'Nombre del Estudiante',
                nombre_curso: 'Nombre del Curso',
                ci: 'Cédula de Identidad',
                creditos: 'Créditos',
                dia: 'Día',
                mes: 'Mes',
                anio: 'Año',
                codigo: 'Código',
                foto: 'Foto',
                qr: 'Código QR'
            };
            return labels[fieldKey] || fieldKey;
        },

        getFieldIcon(fieldKey) {
            const icons = {
                nombre_estudiante: 'mdi-account',
                nombre_curso: 'mdi-book',
                ci: 'mdi-card-account-details',
                creditos: 'mdi-star',
                dia: 'mdi-calendar-today',
                mes: 'mdi-calendar-month',
                anio: 'mdi-calendar-year',
                codigo: 'mdi-barcode',
                foto: 'mdi-camera',
                qr: 'mdi-qrcode'
            };
            return icons[fieldKey] || 'mdi-cog';
        },

        // Maneja el cambio del tipo de pago
        onPaymentTypeChange() {
            if (this.currentCertification.paymentType === 'unico') {
                this.currentCertification.installments = 1;
            } else {
                // Establece un valor por defecto si cambia a cuotas
                if (this.currentCertification.installments < 2) {
                    this.currentCertification.installments = 2;
                }
            }
        },

        // Calcula el monto por cuota
        calculateInstallmentAmount() {
            if (this.currentCertification.amount && this.currentCertification.installments > 0) {
                return (parseFloat(this.currentCertification.amount) / this.currentCertification.installments).toFixed(2);
            }
            return '0.00';
        },

        // Maneja la carga de la imagen del certificado
        onImageChange(file) {
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.currentCertification.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                this.currentCertification.imagePreview = null;
            }
        },

        // Agrega o actualiza una certificación
        addCertification() {
            if (!this.isFormValid) {
                this.showSnackbar('Por favor, completa todos los campos requeridos.', 'error');
                return;
            }

            const newCertification = { ...this.currentCertification }; // Copia profunda o cuidado con objetos anidados

            // Si editingIndex es -1, es una nueva certificación
            if (this.editingIndex === -1) {
                this.certifications.push(newCertification);
                this.showSnackbar('Certificación agregada exitosamente.', 'success');
            } else {
                // Si editingIndex es >= 0, estamos editando una existente
                this.$set(this.certifications, this.editingIndex, newCertification);
                this.showSnackbar('Certificación actualizada exitosamente.', 'info');
                this.cancelEdit(); // Reinicia el formulario después de actualizar
            }
            this.resetForm();
        },

        // Edita una certificación existente
        editCertification(index) {
            this.editingIndex = index;
            // Para evitar mutar directamente el objeto en 'certifications'
            this.currentCertification = JSON.parse(JSON.stringify(this.certifications[index]));

            // Si la imagen ya estaba cargada, asegúrate de que la vista previa también lo esté
            if (this.currentCertification.certificateImage && typeof this.currentCertification.certificateImage === 'string') {
                this.currentCertification.imagePreview = this.currentCertification.certificateImage;
            }
        },

        // Cancela la edición y reinicia el formulario
        cancelEdit() {
            this.editingIndex = -1;
            this.resetForm();
        },

        // Elimina una certificación
        deleteCertification(index) {
            if (confirm('¿Estás seguro de que quieres eliminar esta certificación?')) {
                this.certifications.splice(index, 1);
                this.showSnackbar('Certificación eliminada.', 'warning');
                // Si se elimina la que se estaba editando, cancelar edición
                if (this.editingIndex === index) {
                    this.cancelEdit();
                }
            }
        },

        // Reinicia el formulario a sus valores por defecto
        resetForm() {
            this.currentCertification = {
                university: '',
                amount: '',
                concept: '',
                installments: 1,
                paymentType: 'unico',
                certificateImage: null,
                imagePreview: null,
                certificateFields: this.getDefaultCertificateFields()
            };
            this.editingIndex = -1; // Asegurarse de que no esté en modo edición
        },

        // Genera el JSON del certificado
        generateCertificateJSON() {
            const certData = {
                // No incluir imagePreview en el JSON final, solo la imagen base64 si es necesario o un path
                // Para simplificar, asumimos que certificateImage contendrá el base64 si se cargó un archivo
                // o un path si viene de un backend. Aquí lo dejaremos tal cual para demostración.
                image: this.currentCertification.certificateImage ? this.currentCertification.imagePreview : null, // Puedes enviar la imagen base64 aquí
                fields: { ...this.currentCertification.certificateFields }
            };

            // Eliminar 'valor' de foto y qr si existen en el JSON de campos
            if (certData.fields.foto) delete certData.fields.foto.valor;
            if (certData.fields.qr) delete certData.fields.qr.valor;
            if (certData.fields.qr && certData.fields.qr.url === '') delete certData.fields.qr.url; // Quitar URL si está vacía

            this.formattedJSON = JSON.stringify(certData, null, 2);
            this.jsonDialog = true;
        },

        // Muestra el JSON de un certificado de la lista
        viewCertificateJSON(index) {
            this.currentCertification = JSON.parse(JSON.stringify(this.certifications[index]));
            this.generateCertificateJSON();
        },

        // Copia el JSON al portapapeles
        copyJSON() {
            navigator.clipboard.writeText(this.formattedJSON).then(() => {
                this.showSnackbar('JSON copiado al portapapeles.', 'success');
            }).catch(err => {
                window.console.error('Error al copiar JSON:', err);
                this.showSnackbar('Error al copiar JSON.', 'error');
            });
        },

        // Muestra el snackbar de notificación
        showSnackbar(message, color) {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },

        // Obtiene el precio mínimo de las certificaciones
        getMinPrice() {
            if (this.certifications.length === 0) return '0.00';
            const prices = this.certifications.map(cert => parseFloat(cert.precio));
            return Math.min(...prices).toFixed(2);
        },

        // Obtiene el precio máximo de las certificaciones
        getMaxPrice() {
            if (this.certifications.length === 0) return '0.00';
            const prices = this.certifications.map(cert => parseFloat(cert.precio));
            return Math.max(...prices).toFixed(2);
        }
    }
};
</script>

<style scoped>
/* Puedes añadir estilos específicos para este componente aquí si es necesario */
</style>